module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"no_one_has_written_yet":"아직 아무도 이 상품에 대해 평가하지 않았어요.","no_one_who_has_type_has_written_yet_html":"{userPropertyTypeOptionName} 타입의 구매자는 아직 이 상품에 대해 평가하지 않았어요.","should_write_review":"가장 먼저 리뷰를 작성해 보세요!","write_review":"리뷰 작성하기"}}')
  delete Component.options._Ctor
}
